import React, { Component, ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("ErrorBoundary caught an error:", {
      error: error,
      errorInfo: errorInfo,
      stack: error.stack,
      message: error.message,
    });

    // Log specific AppKit-related errors
    if (
      error.message.includes("getProvider") ||
      error.message.includes("getDefaultChain") ||
      error.message.includes("AppKit") ||
      error.message.includes("WagmiProvider")
    ) {
      console.error("AppKit-related error detected:", error);
    }
  }

  public render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div
            style={{
              padding: "20px",
              textAlign: "center",
              background: "#f8f9fa",
              border: "1px solid #dee2e6",
              borderRadius: "8px",
              margin: "20px",
            }}
          >
            <h2>Something went wrong</h2>
            <p>An error occurred while loading the application.</p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "10px 20px",
                backgroundColor: "#007bff",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Reload Page
            </button>
            {process.env.NODE_ENV === "development" && this.state.error && (
              <details style={{ marginTop: "20px", textAlign: "left" }}>
                <summary>Error Details (Development)</summary>
                <pre
                  style={{
                    background: "#f1f1f1",
                    padding: "10px",
                    borderRadius: "4px",
                    overflow: "auto",
                    fontSize: "12px",
                  }}
                >
                  {this.state.error.stack}
                </pre>
              </details>
            )}
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
